import { initializeSessionTracker, sessionTracker } from '@utils/session/session-activity.util';
import { isProdEnvironment } from '@/settings/environment.utils.js';

export default function (store) {
    if (!window.Cypress) {
        store.subscribe((params, state) => {
            const maxSessionInactivity = state.subscription?.active?.maxSessionInactivity;

            try {
                checkConditions({ maxSessionInactivity, ...params });
            } catch (err) {
                errorMessage(err);
            }
        });

        store.subscribeAction(({ type }) => {
            if (type === 'auth/logout' && sessionTracker) {
                try {
                    sessionTracker.dispose();
                } catch (err) {
                    errorMessage(err);
                }
            }
        });
    }
}

function checkConditions ({ type, payload, maxSessionInactivity }) {
    switch (type) {
        case 'auth/setAuthenticated': {
            if (!payload?.authenticated && sessionTracker) {
                sessionTracker.dispose();
            }

            break;
        }
        case 'subscription/setActive':
        // eslint-disable-next-line no-fallthrough
        case 'subscription/setActiveById': {
            if (!sessionTracker || sessionTracker.inactivityThreshold !== maxSessionInactivity) {
                setupTracker(maxSessionInactivity);
            }

            break;
        }
    }
}

function setupTracker (inactivityThreshold) {
    if (sessionTracker) {
        sessionTracker.dispose();
    }

    const config = {
        inactivityThreshold,
    };

    initializeSessionTracker(config);
}

function errorMessage (err) {
    if (!isProdEnvironment()) {
        // eslint-disable-next-line no-console
        console.warn('Issue setting up session activity with error', err);
    }
}
